var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.login)?_c('v-app',{attrs:{"id":"inspire"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('router-view',{attrs:{"name":"bottomnavigation"}})],1):_c('v-app',{attrs:{"id":"inspire"}},[_c('app-login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }